export const ListingColors = {
  "coming soon": "#9BCE89",
  active: "#599D58",
  "under contract": "#ECD06F",
  closed: "#000000",
  terminated: "#777777",
  upcoming: "#98CFDB",
};
